import React from 'react';
import { connect } from 'react-redux';
import LaDetailedFeedback from './laDetailedFeedback';
import TextFeedback from '../../utils/feedback/textFeedback';

import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';
const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

const LaFeedback = ({
	answerCount,
	rightFeedbackProps: {
		score,
		feedbackQuestionNo,
		feedbackQuestion,
		defaultFeedback,
		laDefaultFeedback: { feedback },
		laDefaultFeedback,
	},
	leftFeedbackProps: { videoId, imagesrc, queDesc },
}) => {
	return (
		<section className="quiz-area-options">
			<TextFeedback />
			<br />
			{!!laDefaultFeedback &&
				(typeof laDefaultFeedback === 'object' ? (
					<LaDetailedFeedback />
				) : (
					<div className="tutor-feedback">
						<i className="fa fa-comments-o" aria-hidden="true"></i>
						<p>
							<span>Feedback</span>
							{defaultFeedback}
						</p>
					</div>
				))}

			<input type="hidden" name="choosen-answer" className="choosen-answer" />
		</section>
	);
};
export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(LaFeedback);
